import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { OperationsGuard } from "../guards/operations.guard";

export const GamificationRoutes: Route[] = [
  {
    path: "gamification",
    loadComponent: () =>
      import("../../Feature/gamification/pages/leaderboard/gamification-leaderboard.component").then(
        (mod) => mod.GamificationLeaderboardComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
];
